export default "__VITE_ASSET__B$gtkuDN__"